import { DeleteOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { isFunction } from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../../AppContext';
import { DEFAULT_CONFIG_KEYS } from '../../workspaces/components';

function CategoryCard({
  href,
  grid,
  lending,
  topic,
  backgroundColor = 'red2',
  textColor = 'text-n-1000',
  responsive,
  onDelete,
  isDeleteAllowed = true,
  ...rest
}) {
  const { state } = useApp();
  const workspaceColors = state?.workspaceConfig?.find(
    ({ key }) => key === DEFAULT_CONFIG_KEYS.COLORS
  )?.value;

  return (
    <Link
      className={`category-card ${textColor} ${grid ? 'category-grid' : ''} ${
        lending ? 'category-lending' : ''
      } ${responsive ? 'responsive-view' : ''}`}
      to={href}
      {...rest}
    >
      <div
        className="category-title"
        // Used inline style as its dynamic value
        style={{
          backgroundColor: workspaceColors?.[backgroundColor]
        }}
      >
        {topic ? <div className="topic">{topic}</div> : null}
      </div>
      {isDeleteAllowed && isFunction(onDelete) && (
        <Tooltip title="Delete Topic">
          <Button
            type="text"
            className="btn-text btn-delete"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete();
            }}
          >
            <DeleteOutlined />
          </Button>
        </Tooltip>
      )}
    </Link>
  );
}
export default CategoryCard;
